import { on } from 'delegated-events'

const fn = {
  init: () => {
    const footerEmbed = document.querySelector('.footer-cc-embed')

    if (footerEmbed) {
      fn.setupFooterForm(footerEmbed)
    }

    on('click', '[data-cc-modal]', fn.handleOpen)
    on('click', '.cc-modal .tingle-modal__close', fn.handleClose)
  },

  setupFooterForm: (el) => {
    const targetNode = el.querySelector('.ctct-inline-form')

    const callback = function (mutationsList, observer) {
      for (const mutation of mutationsList) {
        if (mutation.type === 'childList') {
          fn.handleFormElements(el)
          observer.disconnect()
        }
      }
    }

    if (targetNode) {
      const observer = new MutationObserver(callback)

      observer.observe(targetNode, { childList: true })
    }
  },

  handleOpen: (e) => {
    const target = document.querySelector(e.target.closest('[data-cc-modal]').dataset.ccModal)

    if (target) {
      fn.handleFormElements(target)

      target.classList.add('tingle-modal--visible')
    }
  },

  handleClose: (e) => {
    const modal = e.target.closest('.cc-modal')

    if (modal) {
      modal.classList.remove('tingle-modal--visible')
    }
  },

  handleFormElements: (el) => {
    const emailField = el.querySelector('.ctct-form-element[name="email_address"]')
    const header = el.querySelector('.ctct-form-custom > .ctct-form-header')
    const formText = el.querySelector('.ctct-form-custom > .ctct-form-text')

    if (emailField) {
      emailField.setAttribute('placeholder', 'Enter Your Email to Subscribe')
    }

    if (header) {
      header.parentNode.parentNode.insertBefore(header, header.parentNode)
    }

    if (formText) {
      formText.parentNode.parentNode.insertBefore(formText, formText.parentNode)
    }
  },
}

export default {
  can: () => true,
  run: fn.init,
}
